export default __webpack_public_path__ + "static/media/circle.74ba09c9.svg";